import { securityApi } from '@/service/api/securityApi';
import { message } from '@/utils/message';
import { envConfig } from '../../env';

export function applyTicket(header, serviceType, primaryKey) {
    return new Promise((resolve, reject) => {
        securityApi.applyTicket({
            serviceType: serviceType,
            primaryKey: primaryKey
        }).then(result => {
            if (result.code !== 200) {
                reject();
                return;
            }
            let data = result.data;
            let status = data.captchaStatus;
            let ticket = data.ticket;
            header['ticket'] = ticket;
            if (status === undefined || status === false) {
                resolve();
                return;
            }

            let style = {
                logoUrl: 'https://server.cottongame.com/serverstore/service/logo.png'
            };
            const config = {
                requestCaptchaDataUrl: `${envConfig.formalServer}/plat/sec/captcha/generate`,
                validCaptchaUrl: `${envConfig.formalServer}/plat/sec/captcha/check`,
                bindEl: '#captcha-box',
                requestHeaders: {
                    ticket: ticket
                },
                validSuccess: (res, c, tac) => {
                    header['Captcha'] = res.data;
                    resolve();
                    tac.destroyWindow();
                },
                btnCloseFun: (el, tac) => {
                    reject();
                    tac.destroyWindow();
                },
                generateFail: (res) => {
                    message.error(res.message);
                }
            };
            new TAC(config, style).init();
        });
    });
}
